export const languages = {
    en: 'English',
};
